
/**
 * Internal dependencies
 */
import {
    DISPATCH_PLANS_RECEIVE,
    DISPATCH_PLANS_REQUEST,
    DISPATCH_PLANS_REQUEST_SUCCESS,
    DISPATCH_PLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllDispatchPlans, requestingDispatchPlans } from './selectors';

/**
 * [description]
 * 
 * @param  {Function}   [description]
 * @return {[type]}                  [description]
 */
export const requestDispatchPlans = () => (dispatch) => {
    dispatch({
        type: DISPATCH_PLANS_REQUEST
    });

    return cscom.dispatchPlan().list()
        .then(dispatchPlans => {
            dispatch({ type: DISPATCH_PLANS_REQUEST_SUCCESS });
            dispatch({ type: DISPATCH_PLANS_RECEIVE, payload: { items: dispatchPlans } });
            return dispatchPlans;
        })
        .catch((error) => {
            dispatch({ type: DISPATCH_PLANS_REQUEST_FAILURE, error });
        });
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllDispatchPlans(getState());
	const requesting = requestingDispatchPlans(getState());

	if (plans.length === 0 && requesting === false) {
		return dispatch(requestDispatchPlans(...props))
	}

	return plans;
}